module.exports = __webpack_public_path__ + "img/mtp-app-modules-preview.1cce6183.jpg";